import React, { useCallback, useEffect, useState } from 'react'

import { ReactComponent as SearchIcon } from '../../assets/icons/magnifier.svg'

const SearchBar = ({ handleSearch }) => {
  const [searchbarIsOpen, setSearchbarIsOpen] = useState(false)
  const [textInputValue, setTextInputValue] = useState('')

  const toggleSearchbarState = useCallback((value) => {
    setSearchbarIsOpen(value)
    setTextInputValue('')
    handleSearch(null)

    // eslint-disable-next-line
  }, [])

  const handleEscapeKey = useCallback(({ keyCode }) => {
    const escapeKey = 27

    keyCode === escapeKey && searchbarIsOpen && toggleSearchbarState(false)
  }, [searchbarIsOpen, toggleSearchbarState])

  useEffect(() => {
    document.addEventListener('keydown', handleEscapeKey)

    return () => document.removeEventListener('keydown', handleEscapeKey)
  }, [searchbarIsOpen, handleEscapeKey])

  useEffect(() => {
    handleSearch(textInputValue)
    // eslint-disable-next-line
  }, [textInputValue])


  const handleInputChange = ({ target: { value } }) => {
    setTextInputValue(value)
  }


  return (
    <div className='search-attendant'>
      <label data-searchbar-is-open={searchbarIsOpen}>
        <SearchIcon />
        <input
          placeholder="Search..."
          type="text"
          value={textInputValue}
          onChange={handleInputChange}
          onClick={() => toggleSearchbarState(true)}
        />
      </label>
    </div>
  )
}

export default SearchBar
